// FILE: src/pages/Auth/Index.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from '../../../public/assets/images/logo.svg'; // اطمینان از مسیر لوگو
import Input from 'components/ui/Input';
import Button from 'components/ui/Button';
import api from 'utils/api';
import { toast } from 'react-hot-toast';

function LoginIndex() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // اتصال به API واقعی
      // نکته: در بک‌اند باید روت /auth/login وجود داشته باشد
      const credentials = {
        username: formData.username,
        password: formData.password,
      };

      const response = await api.post('/auth/login', credentials);

      if (response.data.token) {
        localStorage.setItem('token', response.data.token);
        // ذخیره اطلاعات ادمین در صورت نیاز
        if (response.data.user) {
          localStorage.setItem('adminUser', JSON.stringify(response.data.user));
        }

        toast.success('خوش آمدید');
        navigate('/provider-dashboard');
      }
    } catch (error) {
      console.error(error);
      toast.error(
        error.response?.data?.message ||
          (error.response?.status === 404
            ? 'مسیر ورود در سرور پیدا نشد؛ آدرس API را بررسی کنید.'
            : 'ورود انجام نشد؛ نام کاربری، رمز عبور و اتصال را بررسی کنید.')
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      dir="rtl"
      className="flex min-h-screen flex-col justify-center bg-background px-6 py-12 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-sm text-center">
        <img
          className="mx-auto h-24 w-auto object-contain mb-4"
          src={Logo}
          alt="Panah Logo"
          onError={(e) => {
            e.target.style.display = 'none';
          }} // Fallback if logo missing
        />
        <h2 className="mt-2 text-2xl font-bold tracking-tight text-foreground">
          ورود به پنل مدیریت پناه
        </h2>
        <p className="mt-2 text-sm text-muted-foreground">
          برای مدیریت خدمات، لطفا وارد شوید
        </p>
      </div>

      <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
        <div className="bg-card px-6 py-8 shadow-elevation-2 rounded-lg border border-border">
          <form className="space-y-6" onSubmit={handleSubmit}>
            <Input
              label="نام کاربری / ایمیل"
              type="text"
              required
              value={formData.username}
              onChange={(e) =>
                setFormData({ ...formData, username: e.target.value })
              }
              dir="ltr"
              className="text-left"
            />

            <Input
              label="رمز عبور"
              type="password"
              required
              value={formData.password}
              onChange={(e) =>
                setFormData({ ...formData, password: e.target.value })
              }
              dir="ltr"
              className="text-left"
            />

            <Button type="submit" fullWidth loading={loading} variant="default">
              ورود به حساب
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default LoginIndex;
